import React from 'react';


export default function InDeveloping() {


  return (
    <>
      <h1> This page is under construction </h1>

        <img
          src={`${process.env.PUBLIC_URL}/images/71850c4d6cd020d740e21c0b2b030acb.jpg`}
          style={{
            boxShadow: '10px 10px 20px #3d829c',
            borderRadius: '50px',
            '-webkit-animation': 'slide 0.5s forwards',
            '-webkit-animation-delay': '2s',
            'animation': 'slide 0.5s forwards',
            'animation-delay': '2s',
          }}/>

    </>
  )
}
